import styled, { css } from 'styled-components';

export const Box = styled.div`
  ${({ theme: { spacing, borderRadius, color } }) => css`
    padding: ${spacing.sm} ${spacing.md};
    display: flex;
    flex-direction: column;
    gap: 1px;
    border: 1px solid ${color.blue30};
    border-radius: ${borderRadius.sm};
    background: ${color.white};
    position: relative;
  `}
`;
export const BoxHeader = styled.h2`
  ${({ theme: { font, color } }) => css`
    ${font.h2}
    color: ${color.midnight5};
  `}
`;

export const BoxBody = styled.div`
  ${({ theme: { font, fontSize, color } }) => css`
    ${font.note}
    color: ${color.midnight5};
    text-overflow: ellipsis;
    max-height: 58px;
    position: relative;
    overflow: hidden;
    line-height: ${fontSize.lg};
  `}
`;

export const SeeMore = styled.span`
  ${({ theme: { spacing, color } }) => css`
    position: absolute;
    bottom: 7px;
    right: ${spacing.xs};
    background: white;
    padding: 0 ${spacing.md} 0 0;
    cursor: pointer;
  `}
`;

export const SeeMoreEllipsis = styled.span`
  ${({ theme: { spacing, color } }) => css`
    color: ${color.midnight};
    text-decoration: none;
    margin-right: ${spacing.xs};
  `}
`;
export const SeeMoreText = styled.span`
  ${({ theme: { spacing, color } }) => css`
    text-decoration: underline;
    color: ${color.turquoise};
  `}
`;
